import Chart from "chart.js/dist/chart.js";

export function setupCampaignChartHook() {
  return {
    labels() {
      return JSON.parse(this.el.dataset.labels);
    },
    entries() {
      return JSON.parse(this.el.dataset.entries);
    },
    payments() {
      return JSON.parse(this.el.dataset.payments);
    },
    currentChart: null,
    mounted() {
      Chart.register();
      this.renderChart();
    },
    updated() {
      if (this.currentChart) {
        this.currentChart.destroy();
      }
      this.renderChart();
    },
    renderChart() {
      const ctx = this.el.getContext("2d");

      const entriesGradient = ctx.createLinearGradient(0, 0, 0, 300);
      entriesGradient.addColorStop(0, "rgba(16, 185, 129, 0.25)");
      entriesGradient.addColorStop(1, "rgba(16, 185, 129, 0.02)");

      this.currentChart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: this.labels(),
          datasets: [
            {
              type: "line",
              label: "Submissions",
              data: this.entries(),
              borderColor: "rgb(16, 185, 129)",
              backgroundColor: entriesGradient,
              yAxisID: "yEntries",
              borderWidth: 2,
              tension: 0.3,
              fill: true,
              pointRadius: 3,
              pointHoverRadius: 6,
              pointBackgroundColor: "rgb(16, 185, 129)",
              pointBorderColor: "#fff",
              pointBorderWidth: 2,
              order: 1,
            },
            {
              type: "bar",
              label: "Revenue ($)",
              data: this.payments(),
              backgroundColor: "rgba(20, 184, 166, 0.55)",
              borderColor: "rgb(20, 184, 166)",
              borderWidth: 1,
              borderRadius: 4,
              yAxisID: "yPayments",
              order: 2,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: {
            mode: "index",
            intersect: false,
          },
          plugins: {
            legend: {
              display: true,
              position: "top",
              align: "end",
              labels: {
                usePointStyle: true,
                pointStyle: "circle",
                padding: 20,
                font: { size: 12 },
              },
            },
            datalabels: {
              display: false,
            },
            tooltip: {
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              padding: 12,
              cornerRadius: 8,
              titleFont: { size: 13 },
              bodyFont: { size: 12 },
              callbacks: {
                label: function (context) {
                  if (context.dataset.yAxisID === "yPayments") {
                    return ` Revenue: $${context.parsed.y.toFixed(2)}`;
                  }
                  return ` Submissions: ${context.parsed.y}`;
                },
              },
            },
          },
          scales: {
            x: {
              grid: { display: false },
              ticks: {
                font: { size: 11 },
                color: "#9ca3af",
                maxTicksLimit: 14,
              },
            },
            yEntries: {
              type: "linear",
              position: "left",
              beginAtZero: true,
              ticks: {
                font: { size: 11 },
                color: "#10b981",
                precision: 0,
              },
              grid: {
                color: "rgba(0, 0, 0, 0.04)",
              },
              title: {
                display: true,
                text: "Submissions",
                color: "#10b981",
                font: { size: 11 },
              },
            },
            yPayments: {
              type: "linear",
              position: "right",
              beginAtZero: true,
              ticks: {
                font: { size: 11 },
                color: "#14b8a6",
                callback: (v) => `$${v}`,
              },
              grid: {
                drawOnChartArea: false,
              },
              title: {
                display: true,
                text: "Revenue ($)",
                color: "#14b8a6",
                font: { size: 11 },
              },
            },
          },
        },
      });
    },
  };
}
